import { Component, computed, inject, input, resource } from "@angular/core";
import { NbAlertModule, NbListModule } from "@nebular/theme";
import { FormService } from "app/@core/services/form.service";
import { Lesson } from "app/@core/types";
import { PeerReviewResult } from "app/@core/types/form";

@Component({
  standalone: true,
  selector: "ngx-peer-review-result",
  styleUrls: ["peer-review-result.component.scss"],
  templateUrl: "./peer-review-result.component.html",
  imports: [NbAlertModule, NbListModule],
})
export class PeerReviewResultComponent {
  private formService = inject(FormService);

  lesson = input<Lesson>();

  reviewResultResource = resource({
    request: () => +this.lesson().content,
    loader: async ({ request: formId }) => {
      if (!formId) return null;
      return await this.formService.fetch<PeerReviewResult>(
        `reviews/${formId}`
      );
    },
  });

  readonly reviews = computed(() => {
    const data = this.reviewResultResource.value();
    if (!data) return null;
    return data;
  });
}
